"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slide = void 0;
const lodash_1 = __importDefault(require("lodash"));
var Slide;
(function (Slide) {
    Slide.type = 'slide';
})(Slide || (exports.Slide = Slide = {}));
(function (Slide) {
    var ScreenStateUtils;
    (function (ScreenStateUtils) {
        function toQueryParams(state) {
            return {
                idx: state.visibleBullets.toString(),
                total: state.totalBullets.toString(),
            };
        }
        ScreenStateUtils.toQueryParams = toQueryParams;
        function fromQueryParams(queryData) {
            if (!queryData) {
                return undefined;
            }
            // TODO: is het nodig dat we total bullets opslaan?
            const rawVisibleBullets = lodash_1.default.get(queryData, 'idx');
            const rawTotalBullets = lodash_1.default.get(queryData, 'total');
            const visibleBullets = lodash_1.default.toNumber(rawVisibleBullets) || 0;
            const totalBullets = lodash_1.default.toNumber(rawTotalBullets) || 0;
            return {
                visibleBullets,
                totalBullets,
            };
        }
        ScreenStateUtils.fromQueryParams = fromQueryParams;
    })(ScreenStateUtils = Slide.ScreenStateUtils || (Slide.ScreenStateUtils = {}));
})(Slide || (exports.Slide = Slide = {}));
//# sourceMappingURL=Slide.js.map